export var ExpenseType;
(function (ExpenseType) {
    ExpenseType["salary"] = "salary";
    ExpenseType["office"] = "office";
})(ExpenseType || (ExpenseType = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["cash"] = "cash";
    PaymentMethod["card"] = "card";
    PaymentMethod["other"] = "other";
})(PaymentMethod || (PaymentMethod = {}));
